import { combineReducers } from "redux"
import actionTypes from "actions/actionTypes"
import { createReducer } from "reducers/shared"
import { CountryCode } from "content/CountryMap"
import { RootState } from "reducers/index"
import TestUserActionTypes from "actions/testUserActionTypes"

const { FETCH_USER_INFO_SUCCESS } = actionTypes

const reducers = {
  isAvaActive: createReducer<boolean>(null, {
    [FETCH_USER_INFO_SUCCESS]: (state, action) => action.response.company.isAvaActive,
    [TestUserActionTypes.TOGGLE_IS_AVA_ACTIVE]: (state, action) => !state
  }),

  carrotLite: createReducer<boolean>(null, {
    [FETCH_USER_INFO_SUCCESS]: (state, action) => action.response.company.carrotLite,
    [TestUserActionTypes.TOGGLE_IS_CARROT_LITE]: (state, action) => !state
  }),

  countryCode: createReducer<CountryCode>(null, {
    [FETCH_USER_INFO_SUCCESS]: (state, action) => action.response.company.countryCode
  }),

  parentCompanyOrCompanyName: createReducer<string>(null, {
    [FETCH_USER_INFO_SUCCESS]: (state, action) => action.response.company.parentCompanyOrCompanyName
  }),

  companyName: createReducer<string>(null, {
    [FETCH_USER_INFO_SUCCESS]: (state, action) => action.response.company.companyName
  }),

  parentCompanyName: createReducer<string>(null, {
    [FETCH_USER_INFO_SUCCESS]: (state, action) => action.response.company.parentCompanyName
  }),

  currencySymbol: createReducer<string>(null, {
    [FETCH_USER_INFO_SUCCESS]: (state, action) => action.response.company.currencySymbol
  }),

  isSamlActive: createReducer<boolean>(null, {
    [FETCH_USER_INFO_SUCCESS]: (state, action) => action.response.company.isSamlActive,
    [TestUserActionTypes.TOGGLE_IS_SAML_ACTIVE]: (state, action) => !state
  }),

  supportsDeductiblePlans: createReducer<boolean>(null, {
    [FETCH_USER_INFO_SUCCESS]: (state, action) => action.response.company.supportsDeductiblePlans,
    [TestUserActionTypes.TOGGLE_SUPPORTS_DEDUCTIBLE_PLANS]: (state, action) => !state
  }),

  hasIvfRequirements: createReducer<boolean>(null, {
    [FETCH_USER_INFO_SUCCESS]: (state, action) => action.response.company.hasIvfRequirements,
    [TestUserActionTypes.TOGGLE_ARE_COVERAGE_IVF_REQUIREMENTS_ENABLED]: (state, action) => !state
  }),

  hasAca: createReducer<boolean>(null, {
    [FETCH_USER_INFO_SUCCESS]: (state, action) => action.response.company.hasACA,
    [TestUserActionTypes.TOGGLE_HAS_ACA]: (state, action) => !state
  })
}

type CompanyInfo = typeof reducers
const companyInfo = combineReducers<CompanyInfo>(reducers)

export const getCompanyInfo = (state: RootState) => state.companyInfo
export const getCarrotLite = (state: RootState) => state.companyInfo.carrotLite
export const getCurrencySymbol = (state: RootState) => state.companyInfo.currencySymbol
export const getCountryCode = (state: RootState) => state.companyInfo.countryCode
export const getParentCompanyOrCompanyName = (state: RootState) => state.companyInfo.parentCompanyOrCompanyName
export const getCompanyName = (state: RootState) => state.companyInfo.companyName
export const getParentCompanyName = (state: RootState) => state.companyInfo.parentCompanyName
export const getIsAvaActive = (state: RootState) => state.companyInfo.isAvaActive
export const getIsSamlActive = (state: RootState) => state.companyInfo.isSamlActive
export const getSupportsDeductiblePlans = (state: RootState) => state.companyInfo.supportsDeductiblePlans
export const getCompanyHasIvfRequirements = (state: RootState) => state.companyInfo.hasIvfRequirements
export const getHasAca = (state: RootState) => state.companyInfo.hasAca

export default companyInfo
